import { render, staticRenderFns } from "./SignUpContainer.vue?vue&type=template&id=11304952&"
import script from "./SignUpContainer.vue?vue&type=script&lang=ts&"
export * from "./SignUpContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports